module.exports = __webpack_public_path__ + "img/partner_metropol.6f654431.jpg";